import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // console.log(pathname);
    /* setTimeout make sure this run after components have rendered. This will help fixing bug for some views where scroll to top not working perfectly */
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 0);
  }, [pathname]);
  return null;
};

export const ScrollToBottom = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // console.log(pathname);
    /* setTimeout make sure this run after components have rendered. This will help fixing bug for some views where scroll to top not working perfectly */
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        left: 0,
        behavior: "instant",
      });
    }, 600);
  }, [pathname]);
  return null;
};
